
import React, { memo } from 'react';
import cx from 'classnames';
import { Input, Icon } from '../../../../../ui-kit';


import '../styles/_social-inputs.scss';
import '../styles/_highlighted-icons.scss';

const ICON_MAP = {
  website: 'web',
  facebook: 'facebook',
  twitter: 'twitter',
  linkedIn: 'linkedin',
  other: 'options'
};









function SocialInputs({
  onUpdateField,
  socialProfiles,
  allowedSocialTypes,
  isValidURL,
  disabled
}) {
  return (
    <div className="social-inputs">
      {Object.keys(socialProfiles).map((socialKey) =>
      !allowedSocialTypes || allowedSocialTypes.includes(socialKey) ?

      <Input
        key={socialKey}
        defaultValue={socialProfiles[socialKey].value}
        className={cx('social-inputs__input')}
        value={socialProfiles[socialKey].value}
        prefix={
        <Icon
          name={ICON_MAP[socialKey]}
          className={cx(
            'social-icon',
            `social-icon-${socialKey.toLowerCase()}`,
            { 'social-icon--highlighted': Boolean(socialProfiles[socialKey].value) }
          )}
          color="white"
          size={17} />}


        placeholder={`Enter ${socialKey} URL`}
        onChange={onUpdateField(socialKey)}
        validate={isValidURL}
        errorMessage="Invalid URL"
        disabled={disabled} /> :


      null
      )}
    </div>);

}

export default memo(SocialInputs);